import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, errorMessage } from '../services/api';
import { InfoIcon } from './Icons';

export function VerificationBanner() {
  const { t } = useTranslation();
  const resend = useMutation({ mutationFn: () => api<{ sent: boolean }>('/auth/resend-verification', { body: {} }) });
  return (
    <div className="notice" role="note">
      <InfoIcon size={22} />
      <p>{t('verify.banner')}</p>
      {resend.isSuccess ? (
        <p className="notice__done">{t('verify.sent')}</p>
      ) : (
        <button type="button" className="button button--small" onClick={() => resend.mutate()} disabled={resend.isPending}>
          {t('verify.resend')}
        </button>
      )}
      {resend.isError && <p className="form-error">{errorMessage(resend.error)}</p>}
    </div>
  );
}
